import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  textContent: {
    color: '#7833FF',
    lineHeight: 1.3,
    fontWeight: 'bold',
  },
  logoWrapper: {
    marginTop: theme.spacing(6),
    textAlign: 'center',

    '& img': {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      '& img': {
        marginBottom: 0,
      },
    },
  },
}));
